import {
    Box,
    Container,
    Flex,
    Grid,
    GridItem,
    Heading,
    Link,
    Stack,
    Text,
    VStack,
} from "@chakra-ui/react";
import Head from "next/head";

import Footer from "@/sections/home/Footer";
import Header from "@/sections/home/Header";

const TerminosCondicionesSoyInmobiliaria = () => {
    return (
        <Container maxWidth="100vw" pt={{ base: 14, md: 24 }} px={{ base: 4, lg: 7 }}>
            <Header />
            <Head>
                <title>Terminos y Condiciones Soy Inmobiliaria| Grupo Guía</title>
            </Head>
            <Grid templateColumns="repeat(4, 1fr)" gap={6}>
                <GridItem colSpan={1} display={{ base: "none", md: "block" }} fontSize="16px">
                    <Stack mt="28" mb={4} pl={3}>
                        <Link
                            color="#005895"
                            fontWeight="700"
                            fontSize="sm"
                            href="/terminosycondiciones"
                        >
                            Terminos y condiciones Contratación del portal
                        </Link>
                    </Stack>
                    <Stack my={4} pl={3}>
                        <Link
                            color="#005895"
                            fontWeight="700"
                            fontSize="sm"
                            href="/terminosycondiciones-guiabroker"
                        >
                            Terminos y condiciones Guía broker
                        </Link>
                    </Stack>
                    <Stack my={4} pl={3}>
                        <Link
                            color="#005895"
                            fontWeight="700"
                            fontSize="sm"
                            href="/terminosycondiciones-guiarent"
                        >
                            Terminos y condiciones Guía Rent
                        </Link>
                    </Stack>
                    <Stack my={4} pl={3}>
                        <Link
                            color="#005895"
                            fontWeight="700"
                            fontSize="sm"
                            href="/politicanodiscriminacion"
                        >
                            Política de no discriminación
                        </Link>
                    </Stack>
                    <Stack my={4} pl={3}>
                        <Link
                            color="#005895"
                            fontWeight="700"
                            fontSize="sm"
                            href="/cartaderechosconsumidor"
                        >
                            Carta de derechos del consumidor
                        </Link>
                    </Stack>
                    <Stack my={4} pl={3}>
                        <Link
                            color="#005895"
                            fontWeight="700"
                            fontSize="sm"
                            href="/terminosycondiciones-guiaconnect"
                        >
                            Términos y condiciones Guia Connect
                        </Link>
                    </Stack>
                    <Stack my={4} borderLeftColor="#17669D" borderLeftWidth="3px" pl={3}>
                        <Link
                            color="#005895"
                            fontWeight="700"
                            fontSize="sm"
                            href="/terminosycondiciones-soyinmobiliaria"
                        >
                            Terminos y condiciones Soy Inmobiliaria
                        </Link>
                    </Stack>
                    <Stack my={4} pl={3}>
                        <Link
                            color="#005895"
                            fontWeight="700"
                            fontSize="sm"
                            href="/terminosycondiciones-pagocomprasonline"
                        >
                            Términos y Condiciones para la Selección de Forma de Pago en Compras en
                            Línea
                        </Link>
                    </Stack>
                    <Stack my={4} pl={3}>
                        <Link
                            color="#005895"
                            fontWeight="700"
                            fontSize="sm"
                            href="/terminosycondiciones-alianzas"
                        >
                            Términos y Condiciones - Guía Alianzas
                        </Link>
                    </Stack>
                </GridItem>
                <GridItem colSpan={{ base: 4, md: 3 }}>
                    <Box mb="4" mt="24">
                        <Heading
                            as="h1"
                            fontSize={{ md: "4xl", base: "2xl" }}
                            mb="8"
                            color="accent.500"
                            fontWeight="bold"
                        >
                            Términos y Condiciones Soy Inmobiliaria
                        </Heading>
                    </Box>
                    <Box lineHeight="2" mb="8">
                        <Text>
                            El presente documento describe el proceso de registro de clientes
                            referidos por asesores inmobiliarios externos, con el objetivo de
                            establecer una relación entre Grupo Guía y asesores externos para
                            formalizar la atención al cliente.
                        </Text>
                    </Box>
                    <Box lineHeight="2" mb="12">
                        <Text mb={6} fontWeight="bold" fontSize="2xl" color="accent.500">
                            Términos
                        </Text>
                        <Heading
                            as="h2"
                            mb="6"
                            mt="4"
                            color="accent.500"
                            fontWeight="400"
                            fontSize={{ md: "2xl", base: "xl" }}
                            textAlign="start"
                        >
                            1. Términos, definiciones y términos abreviados
                        </Heading>
                        <Flex my={4}>
                            <Text>
                                Para los propósitos de este documento, se aplican en singular o
                                plural indistintamente, los términos, definiciones y términos
                                abreviados siguientes:
                            </Text>
                        </Flex>
                        <VStack spacing={6} mt={7} ml={20} align="flex-start">
                            <Text>
                                <strong>ASESORES INMOBILIARIOS EXTERNOS: </strong>
                                Agentes o agencias inmobiliarias independientes de Grupo Guia. En
                                este documento también se referirá a ellos como “asesor” o
                                “asesores”.
                            </Text>
                            <Text>
                                <strong>CONCIERGE INMOBILIARIO: </strong>
                                Persona designada por Grupo Guia para la atención de los asesores
                                inmobiliarios externos.
                            </Text>
                            <Text>
                                <strong>DESARROLLOS: </strong>
                                Se refiere a los desarrollos inmobiliarios de los que Grupo Guia
                                tiene autorización para comercializar.
                            </Text>
                            <Text>
                                <strong>CORRETAJE: </strong>
                                Se refiere a las propiedades inmobiliarias de las que Grupo Guía
                                tiene autorización para comercializar.
                            </Text>
                            <Text>
                                <strong>GRUPO GUIA: </strong>
                                Se refiere a la persona moral GUIA EXCELENCIA INMOBILIARIA S.A. DE
                                C.V.
                            </Text>
                        </VStack>
                        <Text mt={5} mb={10}>
                            Documentación Legal y Regulatoria: Para poder cobrar la comisión, el
                            asesor debe proporcionar documentación personal o de la empresa
                            inmobiliaria que demuestre que están legalmente constituidos y cumplen
                            con todas las regulaciones vigentes para operar como corredor
                            inmobiliario en su jurisdicción.
                        </Text>
                        <Flex my={4}>
                            <Text mr={6}>1.1</Text>
                            <Text>
                                <strong>Formalización de relación comercial: </strong>
                                No existirá ni se entenderá existe relación comercial con Grupo Guia
                                sin el contrato firmado de conformidad por ambas partes, que así lo
                                demuestre.
                            </Text>
                        </Flex>
                        <Flex my={4}>
                            <Text mr={6}>1.2</Text>
                            <Text>
                                <strong>Uso Adecuado de Información: </strong>
                                Para asegurar la confidencialidad y protección de la información, el
                                asesor deberá acordar y cumplir con las pautas definidas en los
                                documentos de Grupo Guia, mencionando en forma enunciativa más no
                                limitativa: convenio relacionadas con el uso y manejo de la
                                información proporcionada por Grupo Guía, políticas, manuales,
                                términos y condiciones, aviso de privacidad.
                            </Text>
                        </Flex>
                        <Heading
                            as="h2"
                            mb="6"
                            mt={12}
                            color="rgba(0, 43, 73, 1)"
                            fontWeight="400"
                            fontSize={{ md: "2xl", base: "xl" }}
                            textAlign="start"
                        >
                            2. Registro de Clientes:
                        </Heading>
                        <Text mb={8}>
                            {`El registro de clientes se realiza exclusivamente a través de la sección
                                "SOY INMOBILIARIA" en el sitio web de Grupo Guía: www.grupoguia.mx`}
                        </Text>
                        <Flex my={4}>
                            <Text mr={6}>2.1</Text>
                            <Text>
                                <strong>Registro de Clientes en Línea: </strong>
                                La posibilidad de registrar clientes en línea, las 24 horas del día,
                                7 días a la semana, agiliza y simplifica el proceso de trabajo. Este
                                registro será a través de la plataforma seleccionada por Grupo Guia.
                            </Text>
                        </Flex>
                        <Heading
                            as="h2"
                            mb="6"
                            mt={12}
                            color="rgba(0, 43, 73, 1)"
                            fontWeight="400"
                            fontSize={{ md: "2xl", base: "xl" }}
                            textAlign="start"
                        >
                            3. Seguimiento a Posventa
                        </Heading>
                        <Text mb={8}>
                            El equipo de concierge inmobiliario se encarga de dar seguimiento a la
                            posventa de las operaciones, buscando asegurar la satisfacción completa
                            de los clientes y una experiencia integral.
                        </Text>
                        <Heading
                            as="h2"
                            mb="6"
                            mt={12}
                            color="rgba(0, 43, 73, 1)"
                            fontWeight="400"
                            fontSize={{ md: "2xl", base: "xl" }}
                            textAlign="start"
                        >
                            4. No relación laboral:
                        </Heading>
                        <Text mb={8}>
                            El programa SOY INMOBILIARIA es una relación mercantil. Las partes no
                            guardan relación laboral y son responsables en forma directa respecto a
                            las obligaciones que como patrón pudiera tener cada uno con terceros en
                            forma independiente. Las partes deberán dejarse a salvo y en paz
                            respecto de personas que guarden relación laboral con la parte que
                            corresponda.
                            <br />
                            <br />
                            Grupo Guia no dará instrucciones respecto a la forma en que deba
                            trabajar el asesor, limitándose a establecer los términos y condiciones
                            comerciales bajo los que pueden ser comercializas las propiedades a las
                            que da acceso el programa Soy Inmobiliaria.
                        </Text>
                        <Heading
                            as="h2"
                            mb="6"
                            mt={12}
                            color="rgba(0, 43, 73, 1)"
                            fontWeight="400"
                            fontSize={{ md: "2xl", base: "xl" }}
                            textAlign="start"
                        >
                            5. Obligaciones legales y fiscales:
                        </Heading>
                        <Text mb={8}>
                            El programa Soy Inmobiliaria no exime a las partes del cumplimiento
                            directo que por disposición legal deban realizar. Cada una de las partes
                            son responsables de observar y cumplir con lo dispuesto por la
                            legislación que resulte aplicable.
                            <br />
                            <br />
                            En materia de prevención de lavado de dinero, será responsabilidad de
                            las partes atender a la legislación, su reglamento y de resultarle
                            aplicable dar el aviso correspondiente a la autoridad, en tiempo y
                            forma.
                            <br />
                            <br />
                            Las partes coadyuvarán en el cumplimiento de sus obligaciones respecto a
                            la entrega de información y/o documentación que fuere requerida.
                            <br />
                            <br />
                            En materia fiscal, cada una de las partes es responsable de la
                            generación de facturas y pago de impuestos que les corresponda. No
                            existe obligación solidaria.
                            <br />
                            <br />
                            Para el pago de cualquier cantidad que por relación contractual resulte
                            acreedor el asesor, deberá expedir con anticipación una factura que
                            reúna todos los requisitos legales y fiscales aplicables.
                        </Text>
                        <Heading
                            as="h2"
                            mb="6"
                            mt={12}
                            color="rgba(0, 43, 73, 1)"
                            fontWeight="400"
                            fontSize={{ md: "2xl", base: "xl" }}
                            textAlign="start"
                        >
                            6. Inalterabilidad:
                        </Heading>
                        <Text mb={8}>
                            Este documento es un anexo y no sustituye o modifica los acuerdos
                            contractuales que existan entre las partes.
                        </Text>
                        <Heading
                            as="h2"
                            mb="6"
                            mt={12}
                            color="rgba(0, 43, 73, 1)"
                            fontWeight="400"
                            fontSize={{ md: "2xl", base: "xl" }}
                            textAlign="start"
                        >
                            7. Publicidad:
                        </Heading>
                        <Text mb={8}>
                            El programa SOY INMOBILIARIA no se entenderá en ningún momento como una
                            licencia de uso de las marcas con las que “Guia” comercializa o bien las
                            de cualquier desarrollador a las que pertenezca cualquiera de las
                            propiedades.
                            <br />
                            <br />
                            Todas las fotografías, videos y material publicitario con el que “Guia”
                            promueve las propiedades son derechos reservados y el programa “Soy
                            Inmobiliaria” no otorga una licencia de uso por lo que no se deberá
                            utilizar en forma total o parcial, bajo ningún medio, por parte de los
                            asesores.
                        </Text>
                        <Heading
                            as="h2"
                            mb="6"
                            mt={12}
                            color="rgba(0, 43, 73, 1)"
                            fontWeight="400"
                            fontSize={{ md: "2xl", base: "xl" }}
                            textAlign="start"
                        >
                            Conclusión:
                        </Heading>
                        <Text mb={20}>
                            El Programa Soy Inmobiliaria es una iniciativa diseñada para enriquecer
                            el ecosistema inmobiliario a través de alianzas estratégicas entre Grupo
                            Guía y asesores inmobiliarios externos. Al reunir a profesionales
                            calificados y comprometidos, el programa busca elevar los estándares de
                            la industria y fomentar relaciones mutuamente beneficiosas
                        </Text>
                    </Box>
                </GridItem>
            </Grid>
            <Footer visible={false} />
        </Container>
    );
};

export default TerminosCondicionesSoyInmobiliaria;
